module.exports = __webpack_public_path__ + "static/media/battery_unknown.eef47090.svg";